import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb as RBBreadcrumb } from 'react-bootstrap';

import Link from '../link';

const ManualBreadcrumbItem = ({ href, active, children }) => {
  return (
    <RBBreadcrumb.Item
      active={active}
      linkAs={Link}
      linkProps={{ to: href }}
      href={href}
    >
      {children}
    </RBBreadcrumb.Item>
  );
};

ManualBreadcrumbItem.propTypes = {
  href: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ManualBreadcrumbItem.defaultProps = {
  active: false,
};

export default ManualBreadcrumbItem;
